/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetCachedContentRequest, TGetCachedContentModel, IMappers, TGetCachedContentResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetCachedContentResponseSchema } from '../../entities/get_cached_content/GetCachedContentResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetCachedContentModel(parameters: IGetCachedContentRequest): TGetCachedContentModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'special-promos',
    pathApi: '/v1/get-cached-content/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetCachedContentOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetCachedContentRequest;
}

export async function fetchGetCachedContent<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetCachedContentOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetCachedContentResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetCachedContentModel(parameters),
    config,
  )) as FetchResponse<TGetCachedContentResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetCachedContentResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetCachedContentResponse>;
}
